import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

export default function FormLoadingIndicator() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
      top="0"
      left="0px"
      zIndex={999}
      position={'absolute'}
      // background is theme based, dark or light
      sx={{
        background: theme => theme.palette.background.default,
        opacity: 0.7,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
